import { render } from "./ProfileAdmine.vue?vue&type=template&id=989f89bc&scoped=true"
import script from "./ProfileAdmine.vue?vue&type=script&lang=js"
export * from "./ProfileAdmine.vue?vue&type=script&lang=js"

import "./ProfileAdmine.vue?vue&type=style&index=0&id=989f89bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-989f89bc"]])

export default __exports__